import { Box, Flex, Text } from '@fullstory/components';
import { NoDataSettingsIcon, SpacesNoData } from '@fullstory/graphics';
import React, { PropsWithChildren } from 'react';

type IconType = 'empty-space' | 'no-data';

const icons: { [icon in IconType]: SVGRComponent } = {
  'empty-space': SpacesNoData,
  'no-data': NoDataSettingsIcon,
};

interface EmptyStateProps {
  icon: IconType;
  heading: string;
  description: string;
}

export const EmptyState: React.FC<PropsWithChildren<EmptyStateProps>> = ({
  icon,
  heading,
  description,
  children,
}) => {
  const Icon = icons[icon];

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={24} width="100%">
      <Flex column gap={8}>
        <Text appearance="bodyMedium">
          <Icon height={100} fill="currentColor" />
        </Text>
        <Text appearance="heading2">{heading}</Text>
        <Text appearance="bodyMedium">{description}</Text>
      </Flex>
      {children}
    </Box>
  );
};
